const vacancies = {
  firestorePath: '/vacancies',
  firestoreRefType: 'collection',
  moduleName: 'vacancies',
  statePropName: 'vacancies',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%', // default
      updated_at: '%convertTimestamp%', // default
    },
  },
  state: {},
  getters: {
    getVacancies: (state, getters, rootGetters) => {
      var vacancies = _.toArray(state.vacancies);

      _.map(vacancies, (vacancy) => {
        try{
        var geoCustomer = _.find(rootGetters.customers.customers, (vac) => {
          return vac.id === vacancy.customerId;
        }).geoLocation;

        vacancy.geoLocation = geoCustomer;
        }catch(e){
          console.log(vacancy)
          vacancy.geoLocation = null
        }
        return vacancy
      });

      return vacancies
    },

    getVacanciesFromCustomer: (state, getters) => (id) => {
      if (!id) {
        return getters.getVacancies
      }

      var vacanciesFiltered = _.filter(getters.getVacancies, (vac) => {
        return (vac.customerId === id) && (vac.amount !== 0)
      });

      return vacanciesFiltered
    },

    getVacancyExperiences: (state) => {
      let vacancies = _.toArray(state.vacancies);
      let shifts = _.map(vacancies, 'experiences');
      let merged = [].concat.apply([], shifts);
      return _.uniq(merged).sort();
    },

    getVacancyName: (state) => (id) => {
      let vacancies = _.toArray(state.vacancies);
      let vacancy = _.find(vacancies, ['id', id]);
      if (vacancy) {
        return vacancy.name
      } else {
        return '-'
      }
    },
  },
  mutations: {},
  actions: {
    setVacancies: payload => {
      payload.commit('setVacancies')
    },
  },
}

export default vacancies